import { yup } from '@guiker/yup-util'

export const invitedUnitManagerClaimsSchema = yup.object({
  userId: yup.string().required(),
  emailAddress: yup.string().required(),
})

export type InvitedUnitManagerClaimsSchema = yup.InferType<typeof invitedUnitManagerClaimsSchema>
